import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import { Container } from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Caret from '../../public/site-assets/svg/caret.svg';

export const VideoBanner = ({
    className,
    title,
    content,
    buttonTitle,
    buttonLink,
    image,
    videoLink,
}) => {

    Fancybox.bind("[data-fancybox]");

    return (
        <section className={`${styles.root} ${className}`}>
            <Container>
                <div className="position-relative p-md-5 p-4 rounded-3 overflow-hidden">
                    <div className="imageWrapper position-absolute">
                        <SourceFlowImage
                            src={image?.url ? image?.url : "/site-assets/placeholders/img-placeholder.jpg"}
                            size="1000x"
                            alt={image?.alt ?? "Video Banner Image"}
                            className="card-img rounded-0"
                        />
                    </div>
                    <div className="position-relative">
                        <div className="contentWrapper">
                            {title &&
                                <h2>{title}</h2>
                            }
                            {content &&
                                <div dangerouslySetInnerHTML={{ __html: content }} />
                            }
                            {videoLink &&
                                <a
                                    className="fancyBox d-inline-block position-absolute"
                                    data-fancybox="videoBanner"
                                    href={videoLink}
                                    aria-label="Play"
                                >
                                    <span className="play">
                                        <Caret />
                                    </span>
                                </a>
                            }
                        </div>
                        {buttonLink &&
                            <div>
                                <Link href={`${buttonLink}`}>
                                    <a className="primaryBtn no-arrow m-0">
                                        {buttonTitle}
                                    </a>
                                </Link>
                            </div>
                        }
                    </div>
                </div>
            </Container>
        </section>
    )
}

export default VideoBanner;
